import React, { useState, useEffect } from 'react';
import { Card, Btn, Badge, Divider, Header, BottomNav, UploadIcon, ClockIcon, ShieldIcon } from '../components/SharedComponents';
import C from '../styles/tokens';

const BuyUSDT = ({ navigate }) => {
  const [inrAmount] = useState('900');
  const [timer, setTimer]   = useState('09:31');

  const usdt = inrAmount ? (parseFloat(inrAmount) / 90).toFixed(2) : '0.00';

  useEffect(() => {
    let secs = 9 * 60 + 31;
    const iv = setInterval(() => {
      secs--;
      if (secs <= 0) { clearInterval(iv); setTimer('00:00'); return; }
      const m = String(Math.floor(secs / 60)).padStart(2, '0');
      const s = String(secs % 60).padStart(2, '0');
      setTimer(`${m}:${s}`);
    }, 1000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="page-wrapper fade-in">
      <Header title="Buy USDT" onBack={() => navigate('dashboard')} />

      <div className="page-content">

        {/* Order Info Card */}
        <Card style={{ marginBottom: 14 }}>
          <div className="flex justify-between items-center mb-12">
            <span className="font-mono" style={{ fontSize: 12, color: C.textMuted }}>
              Order #XD73826A9F01
            </span>
            <Badge color={C.warning}>Awaiting Payment</Badge>
          </div>

          <Divider />

          {/* Exchange Row */}
          <div className="exchange-row">
            <div className="exchange-box exchange-box-pay">
              <div className="exchange-box-label">You Pay</div>
              <div className="exchange-box-amount" style={{ color: C.textPrimary }}>
                ₹{inrAmount}
              </div>
            </div>
            <div style={{ color: C.textMuted }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </div>
            <div className="exchange-box exchange-box-receive">
              <div className="exchange-box-label">You Receive</div>
              <div className="exchange-box-amount" style={{ color: C.accent }}>
                {usdt} <span style={{ fontSize: 13 }}>USDT</span>
              </div>
            </div>
          </div>

          {/* Rate Info */}
          <div className="flex justify-between mt-12" style={{ fontSize: 13 }}>
            <span style={{ color: C.textMuted }}>Rate</span>
            <span style={{ fontWeight: 700, color: C.textPrimary }}>₹90 / USDT</span>
          </div>
          <div className="flex justify-between mt-4" style={{ fontSize: 13 }}>
            <span style={{ color: C.textMuted }}>Network Fee</span>
            <span style={{ fontWeight: 700, color: C.accent }}>₹0</span>
          </div>
        </Card>

        {/* Payment Method Card */}
        <Card style={{ marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 12 }}>Payment Method</div>

          <div style={{
            background: C.primaryLight, borderRadius: 12,
            padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: 10, background: C.primary,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="#fff" strokeWidth="2">
                <rect x="1" y="4" width="22" height="16" rx="2"/>
                <line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: C.textPrimary }}>UPI</div>
              <div style={{ fontSize: 12, color: C.textMuted }}>example@upi</div>
            </div>
          </div>

          {/* QR Code */}
          <div className="qr-box">
            <div className="qr-inner">
              <svg width="120" height="120" viewBox="0 0 21 21" fill={C.textPrimary}>
                <path d="M0 0h9v9H0zm1 1v7h7V1zm1 1h5v5H2zM12 0h9v9h-9zm1 1v7h7V1zm1 1h5v5h-5zM0 12h9v9H0zm1 1v7h7v-7zm1 1h5v5H2zM17 12h1v1h1v1h-1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h1v-1h-1v-1h1v-1h1zm-5 0h1v1h1v1h-1v1h-1v-1h-1v-1h1zm3 4h1v1h1v1h-1v1h-1v-1h-1v-1h1zM3 3h3v3H3zm8 0h3v3h-3zm-8 8h3v3H3z"/>
              </svg>
              <div style={{ fontSize: 11, color: C.textMuted, marginTop: 6 }}>
                Scan with any UPI app
              </div>
            </div>
          </div>
        </Card>

        {/* Timer Alert */}
        <div className="alert-warning">
          <ClockIcon color={C.warning} />
          <span style={{ fontSize: 13, color: C.warning, fontWeight: 700 }}>
            Payment window closes in {timer}
          </span>
        </div>

        {/* Security Note */}
        <div className="alert-success">
          <ShieldIcon />
          <div style={{ fontSize: 12, color: C.textSecondary }}>
            <strong>Secure Manual Verification</strong><br />
            Avg confirmation: 5–10 min • All transactions monitored
          </div>
        </div>

        {/* Actions */}
        <Btn
          onClick={() => navigate('paymentVerification')}
          variant="primary" full size="lg"
          icon={<UploadIcon />}
        >
          Upload Payment Screenshot
        </Btn>

        <Btn
          onClick={() => navigate('dashboard')}
          variant="ghost" full size="md"
          style={{ marginTop: 10 }}
        >
          Cancel Order
        </Btn>
      </div>

      <BottomNav active="buy" navigate={navigate} />
    </div>
  );
};

export default BuyUSDT;
